(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["daymerit-media-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('daymerit-inline-media-slider')) {
    class DaymeritInlineMediaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-media-track]');
        this.prev = this.querySelector('[data-media-prev]');
        this.next = this.querySelector('[data-media-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.handlePrev = () => this.scrollByCard(-1);
        this.handleNext = () => this.scrollByCard(1);
        this.handleScroll = () => this.syncButtons();

        this.prev.addEventListener('click', this.handlePrev);
        this.next.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.syncButtons());
        this.resizeObserver.observe(this.track);

        this.mutationObserver = new MutationObserver(() => this.syncButtons());
        this.mutationObserver.observe(this.track, { childList: true, subtree: true });

        this.syncButtons();
        this.ensurePosition();
        this.syncProductGridWidth();
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.handlePrev);
        this.next?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      syncProductGridWidth() {
        const wrapper = this.closest('.daymerit-inline-media-slider');
        const grid = this.closest('.product-information__grid');
        if (!wrapper || !grid) return;

        const rightColumn = getComputedStyle(wrapper)
          .getPropertyValue('--dm-right-column-desktop')
          .trim();

        if (rightColumn) {
          grid.style.setProperty('--dm-right-column-desktop', rightColumn);
        }
      }

      ensurePosition() {
        const wrapper = this.closest('.daymerit-inline-media-slider');
        const details = this.closest('.product-details');
        const questions = details?.querySelector('.daymerit-common-questions');

        if (wrapper && questions && wrapper.nextElementSibling !== questions) {
          questions.before(wrapper);
        }
      }

      getStep() {
        const card = this.track.querySelector('.daymerit-media-item');
        if (!card) return Math.max(120, this.track.clientWidth * 0.35);
        const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({
          left: direction * this.getStep(),
          behavior: 'smooth'
        });
      }

      syncButtons() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const scrollable = max > 4;

        this.prev.hidden = !scrollable;
        this.next.hidden = !scrollable;

        if (!scrollable) return;

        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      }
    }

    customElements.define('daymerit-inline-media-slider', DaymeritInlineMediaSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
